import { extractErrorMessage } from "utils/ErrorHandlers";
import ecomInterceptor from "../interceptors/ecomInterceptor";
import { ITEM_TYPES } from "utils/itemTypeHelpers";

const cartService = {
  getCartByUser: async (
    userId: string,
    isAlertRequired: boolean
  ): Promise<any> => {
    try {
      const response = await ecomInterceptor.get(
        `/cart?userId=${userId}&isAlertRequired=${isAlertRequired}`
      );
      return response.data.data;
    } catch (error: any) {
      throw new Error(extractErrorMessage(error) || "Failed to fetch cart");
    }
  },

  updateCart: async (
    actionType: string,
    userId: string,
    productId: string,
    variantId: string,
    quantity: number,
    itemType?: typeof ITEM_TYPES[keyof typeof ITEM_TYPES],
    productGroupId?: string,

  ): Promise<any> => {
    try {
      const response = await ecomInterceptor.post("/cart", {
        actionType,
        userId,
        productId,
        variantId,
        quantity,
        itemType: itemType || ITEM_TYPES.PRODUCTS, // Default to 'products' if not provided
        productGroupId,

      });
      return response.data.data;
    } catch (error: any) {
      throw new Error(extractErrorMessage(error) || "Failed to update cart");
    }
  },

  bulkAddToCart: async (
    items: {
      productId: string;
      variantId: string;
      quantity: number;
      itemType?: typeof ITEM_TYPES[keyof typeof ITEM_TYPES];
      productGroupId?: string;

    }[]
  ): Promise<any> => {
    try {
      const response = await ecomInterceptor.post("/cart/bulk-insert", {
        products: items.map(item => ({
          ...item,
          itemType: item.itemType || ITEM_TYPES.PRODUCTS, // Default to 'products'
          productGroupId: item.productId || '',

        })),
      });
      return response.data.data;
    } catch (error: any) {
      throw new Error(
        extractErrorMessage(error) || "Failed to bulk add items to cart"
      );
    }
  },

  clearCart: async (actionType: string): Promise<any> => {
    try {
      const response = await ecomInterceptor.post("/cart", {
        actionType,
        itemType: ITEM_TYPES.PRODUCTS,
      });

      return response.data;
    } catch (error: any) {
      throw new Error(extractErrorMessage(error) || "Failed to clear cart");
    }
  },
};

export default cartService;
